import { render, staticRenderFns } from "./epg-lock-icon.vue?vue&type=template&id=a014eb64"
import script from "./epg-lock-icon.vue?vue&type=script&setup=true&lang=js"
export * from "./epg-lock-icon.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports